import ubBanzai from 'ub/control/banzai-features';
import _ from 'lodash';

const obscureErrorMessage = (error) => {
  if(error.dataPath) {
    //We want to drop the element index as that will make the errors too specific.
    return `${error.message} at ${_.last(error.dataPath.split(/^\/?[0-9]+\//))}`;
  }

  return error.message;
};

const logError = (lp, validation) => {
  if(ubBanzai.features.isDebugModeEnabled()) {
    console.log('******* POM VALIDATION FAILED ON SAVE *******', validation);
  }

  const firstErr = validation.errors[0];
  const message = obscureErrorMessage(firstErr);

  const errorLength = validation.errors.length;
  const details = `${errorLength} validation errors found: ${firstErr}`;

  lp.errorNotifier.captureMessage(`Pom Validation failure during save (${message})`,{
    extra: {validationErrors: validation.errors, details: details},
    logger: 'pom-validations'
  });
};

const validatePOM = (lp, pages) => {
  setTimeout(() => {
    try {
      _.each(pages, (page) => {
        const elmAndSettings = JSON.parse(JSON.stringify({elements: page.elementsAsJSO(), settings: page.settings}));
        const elements_validation = window.pomValidator.validate_elements_and_settings;
        const validation = elements_validation(elmAndSettings);

        if(!validation.valid) {
          logError(lp, validation);
        }
      });
    } catch(e) {
      console.log(e);
    }
  });
};

export default {
  obscureErrorMessage,
  logError,
  validatePOM
};



// WEBPACK FOOTER //
// ./src/data/pom-validator.js